import { FunctionComponent } from 'react';
import { faCalendarDays } from '@fortawesome/duotone-light-svg-icons';
import { ConfigurationType, IConfigurationEvent, LinkedProperties } from '@/utilities/forms/ConfigurationFormProcessor';
import ConfigurationItem, { IConfigurationExpandProps } from './ConfigurationItem';
import { useScopedField } from '@ngt/forms-core';

const ConfigurationFormEvent: FunctionComponent<IConfigurationEvent & IConfigurationExpandProps> = ({ setExpanded, toggleExpand, expanded, ...item}) => {
    const {
        trialConfiguration,
        isTrialConfiguration,
        eventPropertyPath,
        eventMetadata
    } = item;

    const isRepeating = !!eventMetadata?.repeating;
    
    return (
        <ConfigurationItem
            toggleExpand={toggleExpand}
            setExpanded={setExpanded}
            expanded={expanded}
            basePropertyPath={eventPropertyPath!}
            edit={true}
            enableable={!isTrialConfiguration}
            expandable={!isTrialConfiguration}
            linkable={!isTrialConfiguration}
            linkedProperties={LinkedProperties[ConfigurationType.Event]}
            title={eventMetadata?.name ?? 'Unknown Event'}
            description={isRepeating ? 'Repeating' : undefined}
            type="Event"
            typeIcon={faCalendarDays}
            item={item}
        />
    );
}

export default ConfigurationFormEvent;